import { jwtDecode } from 'jwt-decode';

const extractTokenData = (token) => {
  const decodedToken = jwtDecode(token);

  return {
    username: decodedToken.preferred_username,
    email: decodedToken.email,
    firstName: decodedToken.given_name,
    lastName: decodedToken.family_name,
    groupTitle: decodedToken.group_title,
    themeColors: decodedToken.theme_colors,
  };
};

export default extractTokenData;
